"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DrawerWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DrawerWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tleft: ", ";\n\ttop: ", ";\n\tright: ", ";\n\tbottom: ", ";\n\ttransition-delay: 400ms;\n\ttransform: ", ";\n\ttransition: transform ease-in-out 300ms;\n\t", ";\n\t", ";\n\theight: ", ";\n\twidth: ", ";\n\t", ";\n\t", ";\n"])), function (props) {
  return props.drawerPosition === 'left' ? '0' : '';
}, function (props) {
  return props.drawerPosition === 'top' ? '0' : '';
}, function (props) {
  return props.drawerPosition === 'right' ? '0' : '';
}, function (props) {
  return props.drawerPosition === 'bottom' ? '0' : '';
}, function (props) {
  if (props.open) {
    return 'translate(0)';
  }
  switch (props.drawerPosition) {
    case 'bottom':
      return 'translateY(100%)';
    case 'top':
      return 'translateY(-100%)';
    case 'right':
      return 'translateX(100%)';
    default:
      return 'translateX(-100%)';
  }
}, (0, _styledSystem.variant)({
  prop: 'variant',
  scale: 'backgrounds'
}), _styledSystem.layout, function (props) {
  return props.drawerPosition === 'left' || props.drawerPosition === 'right' ? '100%' : '';
}, function (props) {
  return props.drawerPosition === 'top' || props.drawerPosition === 'bottom' ? '100%' : '';
}, _styledSystem.color, _styledSystem.position);
exports.DrawerWrapper = DrawerWrapper;